import React from 'react';
import { useTranslation } from 'react-i18next';
import { FinalCTAMessages } from './FinalCTA.messages';
import { HeroMessages } from './Hero.messages';

interface FinalCTAProps {
  onStartTranslating: () => void;
  onSeePricing: () => void;
}

export const FinalCTA: React.FC<FinalCTAProps> = ({ onStartTranslating, onSeePricing }) => {
  const { t } = useTranslation();
  return (
    <section className="final-cta">
      <div className="container">
        <div className="cta-content">
          <h2>{t(FinalCTAMessages.TITLE)}</h2>
          <p className="cta-subtitle">{t(FinalCTAMessages.SUBTITLE)}</p>
          <div className="cta-buttons">
            <button className="btn btn-primary btn-large" onClick={onStartTranslating}>
              {t(HeroMessages.BTN_START_TRANSLATING)}
            </button>
            <button className="btn btn-outline btn-large" onClick={onSeePricing}>
              {t(FinalCTAMessages.BTN_VIEW_PRICING)}
            </button>
          </div>
          {/*
            Was "Free forever · 5,000 words included · No credit card required" —
            hardcoded English, and silent about the multiplier that decides whether
            5,000 words is generous or nothing. Usage is source words x target
            locales, so the count has to be stated wherever the number is.
          */}
          <p className="cta-note">{t(FinalCTAMessages.NOTE)}</p>
        </div>
      </div>
    </section>
  );
};
